export type PinduoduoCatalogSortDirection = 'asc' | 'desc'

export function comparePinduoduoCatalogNumbers(
  left: number | null | undefined,
  right: number | null | undefined,
  direction: PinduoduoCatalogSortDirection,
  leftId: string,
  rightId: string,
) {
  if (left === null || left === undefined) return right === null || right === undefined ? leftId.localeCompare(rightId) : 1
  if (right === null || right === undefined) return -1
  const result = left - right
  return result ? (direction === 'asc' ? result : -result) : leftId.localeCompare(rightId)
}
